<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">To Riyaz Ahmad Mirand <br/>to the fourteen years of our friendship<br/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// arctic-summer_00000.vue?ac034baa